import { useEffect } from "react";

const ASSIGNMENT_FIELDS = ["Emplacements", "Groupes", "Employees"];

const HOUR_FIELDS = new Set([
  "startTime",
  "endTime",
  "startTimeText",
  "endTimeText",
  "startDateTime",
  "endDateTime",
  "dateRange",
  "lunchStartDate",
  "lunchEndDate",
  "startLunchText",
  "endLunchText",
  "isLunchHourShowed"
]);

// Editing dismisses the previous errors; handleSubmit performs the next validation.
export function useClearErrorsOnChange({ watch, clearErrors, getFieldState }) {
  useEffect(() => {
    const subscription = watch((_values, { name, values }) => {
      // Error notifications also reach watch; only value changes dismiss errors.
      if (!values || !name || name === "errors" || name.startsWith("errors.")) return;

      const [section, day, field] = name.split(".");
      if (ASSIGNMENT_FIELDS.includes(section)) {
        // A selection in any of these fields satisfies all three required rules.
        if (ASSIGNMENT_FIELDS.some((fieldName) => _values[fieldName]?.length > 0)) {
          clearErrors(ASSIGNMENT_FIELDS);
        } else {
          clearErrors(section);
        }
      } else if (section === "weeklyHours") {
        if (!day || !HOUR_FIELDS.has(field)) return;
        if (["dateRange", "startDateTime", "endDateTime"].includes(field)) return;

        const hasSectionError = Boolean(getFieldState("weeklyHours").error?.type);
        clearErrors(`weeklyHours.${day}`);
        if (hasSectionError) {
          // Dismiss the section's own error while preserving other days' errors.
          clearErrors(["weeklyHours.type", "weeklyHours.message", "weeklyHours.ref"]);
        }
      } else if (section === "dateRange") {
        clearErrors("dateRange");
      } else if (HOUR_FIELDS.has(section)) {
        clearErrors(["startTime", "endTime", "lunchStartDate", "lunchEndDate"]);
      } else if (!section.startsWith("isEdited")) {
        clearErrors(name);
      }
    });

    return () => subscription.unsubscribe();
  }, [watch, clearErrors, getFieldState]);
}
